import { motion } from "framer-motion";
import { ArrowRight, Sparkles } from "lucide-react";

const CURATED_IDEAS = [
  {
    title: "Engraved Name Mugs",
    subtitle: "Custom ceramic mugs with their name in gold",
    emoji: "☕",
    className: "curatedAmber",
    tag: "Bestseller",
  },
  {
    title: "Personalized Star Map",
    subtitle: "The night sky from the day they were born",
    emoji: "✨",
    className: "curatedIndigo",
    tag: "Romantic",
  },
  {
    title: "Custom Photo Book",
    subtitle: "Your favorite memories, beautifully printed",
    emoji: "📖",
    className: "curatedRose",
    tag: "Memories",
  },
  {
    title: "Graduation Keepsake Box",
    subtitle: "Handcrafted wooden box with engraved message",
    emoji: "🎓",
    className: "curatedEmerald",
    tag: "Milestone",
  },
  {
    title: "Custom Illustration Portrait",
    subtitle: "Hand-drawn digital portrait of them",
    emoji: "🎨",
    className: "curatedSky",
    tag: "Artistic",
  },
  {
    title: "Personalized Jewelry",
    subtitle: "Initial necklaces, birthstone rings & more",
    emoji: "💎",
    className: "curatedViolet",
    tag: "Elegant",
  },
  {
    title: "Custom Recipe Cutting Board",
    subtitle: "Their favorite recipe engraved on bamboo",
    emoji: "🪵",
    className: "curatedYellow",
    tag: "For Foodies",
  },
  {
    title: "Message in a Bottle",
    subtitle: "Handwritten letter in a vintage glass bottle",
    emoji: "🍾",
    className: "curatedTeal",
    tag: "Unique",
  },
];

export default function CuratedGiftIdeas() {
  return (
    <div className="curatedSection">
      <div className="curatedHeader">
        <div className="curatedHeaderIcon">
          <Sparkles size={20} />
        </div>

        <div>
          <h2>Curated Gift Ideas</h2>
          <p>Unique, personalized gift categories to explore</p>
        </div>
      </div>

      <div className="curatedGrid">
        {CURATED_IDEAS.map((idea, index) => (
          <motion.div
            key={idea.title}
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.05 }}
            whileHover={{ y: -4, scale: 1.02 }}
            className={`curatedCard ${idea.className}`}
          >
            <div className="curatedBgEmoji">{idea.emoji}</div>

            <div className="curatedCardContent">
              <span className="curatedEmoji">{idea.emoji}</span>
              <span className="curatedTag">{idea.tag}</span>

              <h3>{idea.title}</h3>
              <p>{idea.subtitle}</p>

              <div className="curatedExplore">
                Explore <ArrowRight size={13} />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}